// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sh8H","footer":"styles_footer__3XCIp","passCodeTooltip":"styles_passCodeTooltip__u141c"};